import { memo } from 'react';
import NextHead from 'next/head';

function Head() {
  return (
    <NextHead>
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <title>adidas Community | Home</title>
      <meta name="description" content="Join adidas Community" />
      <link rel="canonical" href={process.env.NEXT_PUBLIC_WEBSITE_SITE_URL} />
    </NextHead>
  );
}

export default memo(Head);
